import { render, staticRenderFns } from "./VisitedLessons.vue?vue&type=template&id=3fc0acae&scoped=true&lang=pug&"
import script from "./VisitedLessons.vue?vue&type=script&lang=js&"
export * from "./VisitedLessons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fc0acae",
  null
  
)

export default component.exports